import { Skeleton } from '@playbooks/ui/components/skeleton';

import type { SkeletonBaseProps } from './types';

const BasicSkeleton = (props: SkeletonBaseProps) => <Skeleton {...props} />;

export { BasicSkeleton };
